import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
    targetLanguages: Array
  };

  async triggerTranslation(event: Event) {
    event.preventDefault();

    const button = event.currentTarget as HTMLButtonElement;
    button.disabled = true;

    try {
      // Find and show the AI loading overlay
      // The overlay uses BaseComponent pattern, so controller identifier is doubled
      const overlayElement = document.querySelector('.infrastructure--ai-loading-overlay-component');
      
      if (overlayElement) {
        const overlayController = this.application.getControllerForElementAndIdentifier(
          overlayElement,
          'infrastructure--ai-loading-overlay-component--ai-loading-overlay-component'
        );
        
        if (overlayController && typeof (overlayController as any).show === 'function') {
          console.log("Showing overlay");
          (overlayController as any).show();
        } else {
          console.error("Overlay controller not found or show method missing");
        }
      } else {
        console.warn("Overlay element .infrastructure--ai-loading-overlay-component not found in DOM. Ensure it is rendered in the layout.");
      }

      // Get CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

      // Trigger the translation with PATCH method
      console.log("Sending translation request to:", this.urlValue);
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken || ''
        },
        body: JSON.stringify({
          target_languages: this.targetLanguagesValue
        })
      });

      console.log("Response status:", response.status);
      
      if (!response.ok) {
        throw new Error('Translation request failed');
      }

      console.log("Translation request successful, waiting for ActionCable broadcast");
      // The overlay will handle the completion via ActionCable
    } catch (error) {
      console.error('Translation error:', error);
      button.disabled = false;
      
      // Hide overlay on error
      const overlayElement = document.querySelector('.infrastructure--ai-loading-overlay-component');
      if (overlayElement) {
        const overlayController = this.application.getControllerForElementAndIdentifier(
          overlayElement,
          'infrastructure--ai-loading-overlay-component--ai-loading-overlay-component'
        );
        if (overlayController && typeof (overlayController as any).hide === 'function') {
          (overlayController as any).hide();
        }
      }

      alert('Failed to start translation. Please try again.');
    }
  }
}
